import app from 'flarum/forum/app';

/**
 * Los dos enlaces que la casilla de aceptación necesita (PKG-FORO-SMOKE-FIX).
 *
 * SÍNTOMA MEDIDO EN VIVO: «Acepto el código de convivencia y los términos y condiciones» era
 * texto plano dentro del `<label>`. Pulsarlo no abría nada — como mucho marcaba la casilla —,
 * así que el formulario pedía aceptar dos documentos que desde ahí no se podían leer.
 *
 * --- POR QUÉ UN `<a>` PELADO Y NO EL `<Link>` DEL CORE ---
 *
 * `Link` enruta con Mithril: el clic cambiaría de página DENTRO de la SPA y se llevaría por
 * delante todo lo escrito en el formulario (el Form A tiene catorce campos). Estos dos enlaces
 * abren en pestaña nueva, que es además lo que cualquiera espera de unas condiciones dentro de
 * un alta. `rel="noopener noreferrer"` por higiene, aunque el destino sea el propio foro.
 *
 * --- POR QUÉ NO ROMPE LA CASILLA ---
 *
 * Un `<a href>` es «interactive content», y la especificación de HTML dice que la activación
 * del `<label>` NO se aplica a los eventos dirigidos a ese contenido ni a sus descendientes. O
 * sea: pulsar el enlace abre el enlace y deja la casilla como estaba, sin `preventDefault` que
 * pudiera cancelar la navegación. No se da por bueno de memoria — `t15.spec.ts` lo mide, clic
 * a clic, en las dos casillas.
 *
 * Lo que sí hubo que tocar es el guarda del doble clic de T10 (`selectableCheckLabel.ts`), que
 * deshacía un toggle que sobre un enlace nunca llegó a ocurrir.
 *
 * --- A DÓNDE APUNTA CADA UNO ---
 *
 * `conv`  -> `/convivencia`, el código de convivencia (y las normas del grupo n8n Chile, que
 *            son las mismas: no hay un texto aparte).
 * `legal` -> `/privacidad`, que es la única otra superficie legal que existe hoy y la que
 *            describe qué datos se guardan y qué se hace con ellos. NO hay una página
 *            `/terminos` — si algún día se escribe, este es el único sitio que cambia.
 */
export function legalLinkParams(): Record<string, any> {
  return {
    conv: (
      <a
        href={app.route('umbral-comunidad.convivencia')}
        className="CmLegalLink"
        data-cm-legal="convivencia"
        target="_blank"
        rel="noopener noreferrer"
      />
    ),
    legal: (
      <a
        href={app.route('umbral-comunidad.privacidad')}
        className="CmLegalLink"
        data-cm-legal="privacidad"
        target="_blank"
        rel="noopener noreferrer"
      />
    ),
  };
}
